<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        B2B Inventory Summary
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-0 mb-4"></v-divider>
    <v-app>
      <v-data-table
        :headers="_headers"
        :items="list"
        :options.sync="options"
        :server-items-length="total"
        :loading="loader"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [25, 50, 100, 250],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:top>
          <template>
            <div class="custom-row p-5">
              <v-col
                cols="12"
                sm="3"
                md="3"
                class="pb-0"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @focus="fetchClientList"
                  @change="getwarehouse(selectedClient)"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="f_id"
                  :items="warehouses"
                  outlined
                  v-if="selectedClient"
                  @change="getStores(selectedClient, warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0" v-if="selectedClient">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                  @change="callFunc()"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
                class="pb-0"
                v-if="infor_storer_id"
              >
                <v-text-field v-model="sku" outlined label="SKU"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" v-if="infor_storer_id">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  hide-no-data
                  hide-details
                  item-text="text"
                  item-value="value"
                  outlined
                  label="Status"
                  class="pb-2 pt-0 text-center"
                ></v-autocomplete>
              </v-col>
              <v-row class="custom-row pl-5 pr-5" v-if="infor_storer_id">
                <v-col
                  cols="12"
                  :sm="
                    userCategory.user_category === 3 ||
                    userCategory.user_category === 6
                      ? 12
                      : 9
                  "
                >
                  <v-btn color="white" @click="clearAll" style="float: right"
                    >Clear</v-btn
                  >
                  <v-btn
                    color="primary"
                    class="success mr-5"
                    @click="searchAll"
                    style="float: right"
                    >Search</v-btn
                  >
                  <v-btn
                    color="info"
                    class="mr-2 ml-3"
                    v-if="
                      checkPermission(
                        'app_infor:b2b_infor_v1_inventory_download'
                      )
                    "
                    :loading="downloader"
                    style="float: right"
                    @click="download()"
                    >Download</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-divider class="mb-2"></v-divider>
          </template>
        </template>
      </v-data-table>
    </v-app>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.getwarehouse(this.$store.getters.user.id);
    }
  },
  computed: {
    ...mapGetters(["userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client_name"
          : true;
      });
    },
  },
  mounted() {
    this.fetchClientList();
  },
  data() {
    return {
      syncloader: false,
      clientLoader: false,
      infor_storer_id: null,
      downloader: false,
      to_exp_date: null,
      dateMenuTo: false,
      status: null,
      from_exp_date: null,
      options: {},
      stores: [],
      clients: [],
      selectedClient: null,
      total: 0,
      loader: false,
      warehouses: [],
      list: [],
      statuses: [
        { text: "Hold", value: "hold" },
        { text: "Ok", value: "ok" },
      ],
      headers: [
        {
          text: "SKU",
          value: "SKU",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Storer",
          value: "STORERKEY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "DESCR",
          value: "DESCR",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Base UOM",
          value: "BASE_UOM",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Total System Qty",
          value: "SYSTEM_QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Total Allocated Qty",
          value: "QTYALLOCATED",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Picked Qty",
          value: "QTYPICKED",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Hold Qty",
          value: "QTY_ON_HOLD",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Available Qty",
          value: "AVAILABLE_QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
      warehouse_id: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.allFilters();
        if (this.warehouse_id !== null) this.callFunc();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "fetchClient",
      "getInforWarehouseListBB",
      "getWarehouseStores",
      "snackBar",
      "getB2bInventoryList",
      "downloadb2bInventory",
    ]),
    clearDateInput(type) {
      if (type == "this.to_exp_date") {
        this.to_exp_date = "";
      } else {
        this.from_exp_date = "";
      }
    },
    getwarehouse(id) {
      this.warehouse_id = "";
      this.infor_storer_id = null;
      this.sku = null;
      this.status = null;
      this.list = [];

      if (id) {
        this.getInforWarehouseListBB(id).then((response) => {
          this.warehouses = response.data.result;
        });
      }
    },
    getStores() {
      this.infor_storer_id = null;
      this.sku = null;
      this.status = null;
      this.list = [];
      let warehouse = this.warehouses.find(
        (warehouse) => warehouse.f_id === this.warehouse_id
      );
      let id;
      if (warehouse) {
        id = warehouse.id;
      }
      if (id) {
        let payload = {
          client_id: this.selectedClient,
          warehouse_id: id,
        };

        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },
    callFunc() {
      if (this.infor_storer_id) {
        this.allFilters();
        this.loader = true;
        this.getB2bInventoryList({
          ...this.options,
          ...this.selectedClient,
          ...this.filtersArr,
          key: "inventory_item_level_summary",
        })
          .then((res) => {
            this.list = res.data.records;
            this.total = res.data.total;
            this.loader = false;
          })
          .catch(() => {
            this.loader = false;
            this.list = [];
          });
      } else {
        this.list = [];
      }
    },

    getData(e) {
      let searchKey = e.item_skucode;
      if (this.tableDetailsItems[searchKey] !== undefined) {
        return this.tableDetailsItems[searchKey].join(", ");
      }
      return this.tableDetailsItems[searchKey];
    },
    async download() {
      await this.allFilters();

      this.downloader = true;
      this.downloadb2bInventory({
        ...this.selectedClient,
        ...this.filtersArr,
        ...this.options,
        pagination: 0,
        key: "inventory_item_level_summary",
      })
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    clearAll() {
      this.filtersArr = [];
      this.sku = null;
      this.to_exp_date = null;
      this.from_exp_date = null;
      this.status = null;
      this.callFunc();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        storer_id: this.infor_storer_id,
        warehouse_id: this.warehouse_id,
        sku: this.sku ? this.sku.trim() : null,
        from_exp_date: this.from_exp_date,
        to_exp_date: this.to_exp_date,
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.list = [];
      this.options.page = 1;
      this.allFilters();
      await this.getB2bInventoryList({
        ...this.options,
        ...this.filtersArr,
        key: "inventory_item_level_summary",
      })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active: "True",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
</style>
